import React from 'react';

const PricingToggle = ({ billingCycle, onToggle }) => {
  return (
    <div className="flex items-center justify-center space-x-3 md:space-x-4">
      <span className={`
        text-sm md:text-base font-medium transition-base
        ${billingCycle === 'monthly' ? 'text-foreground' : 'text-muted-foreground'}
      `}>
        Monthly
      </span>
      
      <button
        onClick={onToggle}
        className="relative w-14 h-7 md:w-16 md:h-8 bg-muted rounded-full transition-base focus-ring"
        aria-label="Toggle billing cycle"
      >
        <div className={`
          absolute top-1 left-1 w-5 h-5 md:w-6 md:h-6 bg-primary rounded-full transition-base
          ${billingCycle === 'annual' ? 'translate-x-7 md:translate-x-8' : 'translate-x-0'}
        `} />
      </button>
      
      <div className="flex items-center space-x-2">
        <span className={`
          text-sm md:text-base font-medium transition-base
          ${billingCycle === 'annual' ? 'text-foreground' : 'text-muted-foreground'}
        `}>
          Annual
        </span>
        <span className="px-2 py-1 bg-success/10 text-success text-xs font-medium rounded-full">
          Save 20%
        </span>
      </div>
    </div>
  );
};

export default PricingToggle;